var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrganization(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5833333333333334,0,0,0.5833333333333334,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.13,18.23A.25.25,0,0,1,22,18a7,7,0,0,0-7-6.52H13.25a.25.25,0,0,1-.25-.25V6a.24.24,0,0,1,.15-.23,3,3,0,1,0-2.3,0A.24.24,0,0,1,11,6v5.26a.25.25,0,0,1-.25.25H8.5A6.56,6.56,0,0,0,2,18a.23.23,0,0,1-.15.21,3,3,0,1,0,2.32,0A.26.26,0,0,1,4,18,4.52,4.52,0,0,1,8.5,13.5h2.25a.25.25,0,0,1,.25.25V18a.25.25,0,0,1-.15.23,3,3,0,1,0,2.3,0A.25.25,0,0,1,13,18V13.75a.25.25,0,0,1,.25-.25H15A5,5,0,0,1,20,18a.26.26,0,0,1-.14.26,3,3,0,1,0,2.32,0Z",
    style: {
      fill: "current"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganization);
export default __webpack_public_path__ + "static/media/organization.af458d3b2f94f90976f225b34e0f9d54.svg";
export { ForwardRef as ReactComponent };